import { Resource } from 'react-admin'
import { debug } from '../test'
import { Permissions } from '../types/apiTypes'
import gemeenten from './Gemeenten'
import stadsprognose from './Stadsprognose'
import gebiedsprognose from './Gebiedsprognose'
import { stad as historischeDataStad, gebied as historischeDataGebied } from './HistorischeData'
import { stad as overigeDataStad, gebied as overigeDataGebied } from './OverigeData'

const availableResources = ({scopes}: Permissions): JSX.Element[] => [
  <Resource
    key="historische_data_stad"
    name="historische_data_stad"
    options={{
      label: 'Stad',
      submenu: 'historische_data',
      scopes: ['labs:all'],
    }}
    list={historischeDataStad.list}
    icon={historischeDataStad.icon}
  />,
  <Resource
    key="historische_data_gebied"
    name="historische_data_gebied"
    options={{
      label: 'Gebied',
      submenu: 'historische_data',
      scopes: ['labs:all'],
    }}
    list={historischeDataGebied.list}
    icon={historischeDataGebied.icon}
  />,
  <Resource
    key="prognose_sets"
    name="prognose_sets"
    options={{
      label: 'Stad',
      submenu: 'prognoses',
      scopes: ['labs:all']
    }}
    list={stadsprognose.list}
    create={stadsprognose.create}
    show={stadsprognose.show}
    icon={stadsprognose.icon}
  />,
  <Resource
    key="gebiedsprognoses"
    name="gebiedsprognoses"
    options={{
      label: 'Gebied',
      submenu: 'prognoses',
      scopes: ['labs:all']
    }}
    list={gebiedsprognose.list}
    create={gebiedsprognose.create}
    show={gebiedsprognose.show}
    icon={gebiedsprognose.icon}
  />,
  <Resource
    key="overige_data_stad"
    name="overige_data_stad"
    options={{
      label: 'Stad',
      submenu: 'overige_data',
      scopes: ['labs:all'],
    }}
    list={overigeDataStad.list}
    icon={overigeDataStad.icon}
  />,
  <Resource
    key="overige_data_gebied"
    name="overige_data_gebied"
    options={{
      label: 'Gebied',
      submenu: 'overige_data',
      scopes: ['labs:all'],
    }}
    list={overigeDataGebied.list}
    icon={overigeDataGebied.icon}
  />,
  <Resource
    key="gemeenten"
    name="gemeenten"
    options={{
      label: 'Gemeenten',
      submenu: 'beheer',
      scopes: ['labs:all'],
    }}
    list={gemeenten.list}
    create={gemeenten.create}
    show={gemeenten.show}
    edit={gemeenten.edit}
    icon={gemeenten.icon}
  />,
]

const fallback = (): JSX.Element[] => [
  <Resource
    key="gemeenten"
    name="gemeenten"
    options={{
      label: 'Gemeenten',
    }}
    list={gemeenten.list}
    icon={gemeenten.icon}
  />
]

export const resourcesForScopes = ({ scopes }: Permissions): JSX.Element[] => {
  debug && console.log({scopes})
  if (!scopes || scopes.length === 0) {
    console.warn('No scopes received, returning fallback resource')
    return fallback()
  }
  const resources = availableResources({ scopes })
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
    .filter(resource => resource.props.options.scopes.find(scope => scopes.includes(scope)) !== undefined)
  if (!resources || resources.length === 0) {
    console.warn('No resources received, returning fallback resource')
    return fallback()
  }
  return resources
}
